import { SVGProps } from 'react';

export const SortAscIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
      <path
        fill="currentColor"
        d="M17.293 3.465a1 1 0 0 1 1.32-.084l.094.084l2.828 2.828a1 1 0 0 1-1.32 1.497l-.094-.083L19 6.586V19a1 1 0 0 1-1.993.117L17 19V6.586l-1.121 1.121a1 1 0 0 1-1.498-1.32l.083-.094zM13 18a1 1 0 0 1 .117 1.993L13 20H4a1 1 0 0 1-.117-1.993L4 18zm0-7a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2zm-2-7a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2z"
      />
    </g>
  </svg>
);
